<template>
    <Page type="gray" :nopadding="false">
        <template v-slot:body>
            <div class="w-full flex flex-column">
                <div class="w-full flex gap-5 mb-3 align-items-center
                    px-3 xl:px-0 lg:px-0 md:px-0
                    flex-column xl:flex-row lg:flex-row md:flex-row">
                    <SelectButton v-model="active_index" :options="tabs" optionLabel="label" optionValue="index" dataKey="title" size="small" class="mt-2 ">
                        <template #option="slotProps">
                            <span class="text-sm py-1 white-space-nowrap">{{ slotProps.option.label[lang] }}</span>
                        </template>
                    </SelectButton>
                </div>
                <EsimFilter v-if="active_index === 1" />
                <EsimOrders v-else @no_orders="active_index = 1"/>
            </div>
        </template>
    </Page>
</template>

<script>
import Connect from         '@/assets/js/Connect'
import Helper from          '@/assets/js/Helper'
import Page from            '@/components/sides/Page.vue' 
import WalletWidget from    '@/components/personal/wallet/WalletWidget.vue'
import EsimFilter from      '@/components/personal/products/esim_filter.vue'
import EsimOrders from      '@/components/personal/products/esim_orders.vue'
import { mapActions } from  'vuex'

export default {
    data() {
        return {
            header: {
                en: { title: 'Products' },
                ru: { title: 'Продукты' }
            },
            content: {
                ru: { 
                    btnSupport: 'Поддержка',
                },
                en: { 
                    btnSupport: 'Support',
                }
            },
            wallet: null,
            wallet_id: null,
            loading: false,
            active_index: 0,
            tabs: [
                {
                    "label": {
                        "en": "My plans",
                        "ru": "Мои тарифы",
                    },
                    "codes": null,
                    "disabled": false,
                    "index": 0
                },
                {
                    "label": {
                        "en": "All plans",
                        "ru": "Все тарифы",
                    },
                    "codes": ["card", "stock", "sbp", "swift"],
                    "disabled": false,
                    "index": 1
                },
            ],
        }
    },
    components: {
        Page,
        WalletWidget,
        EsimFilter,
        EsimOrders
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screen_size() { return this.$store.getters.StateScreenSize },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
        depositWalletId() { return this.getDepositWalletId(this.$store.getters.StateWallets)},
        wallets() { return this.$store.getters.StateWallets },
    },
    watch: {
        wallets: {
            handler(list) {
                if(!list || !Array.isArray(list)) return
                this.wallet = list.find(wallet => wallet.type === 'vcard')
            },
            immediate: true
        },
    },
    methods: {
        ...mapActions(['ActionGetWalletByType', 'SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
        isUserInGroup (type) { return this.helper.isUserInGroup(type, this.$store.getters.StateGroups) },
        getWalletNameByType(type) {
            return this.helper.getWalletNameByType(type, this.lang)
        },
        getDepositWalletId(list) {
            if(!list || !Array.isArray(list)) return null
            if(list && list.length > 0) {
                for (let i = 0; i < list.length; i++) {
                    if(list[i].type == 'deposit') return list[i].id
                }
            } else return null
        },
        async refresh(){
            this.loading = true
            try { await this.ActionGetWalletByType('vcard').then(res=>res) } 
            catch (error) { console.log(error) }
            this.loading = false
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.helper.SetTgAppHeadColor('white', this.isDarkTheme)

        try {
            this.SetHeaderTitle(this.header[this.lang].title)
            this.SetHeaderBtnLeftFirst({
                type: 'link',
                link: null,
                icon: 'pi pi-comments',
                class: 'text-xs opacity-0',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                type: 'link',
                link: '/support/',
                label: null,
                icon: 'pi pi-comments',
                iconPos: 'right',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    }
}
</script>